/**
  * @param {Object} dispatchUpdate
  * @returns {Object}
*/
export function towBookDispatchStatusUpdateParser(dispatchUpdate) {
  return {
    assignedDriver: dispatchUpdate.assignedDriver ? {
      name: dispatchUpdate.assignedDriver.name,
      id: dispatchUpdate.assignedDriver.id
    } : null,
    assignedVehicle: {
      geoPoint: {
        latitude: dispatchUpdate?.assignedDriver?.latitude || dispatchUpdate.latitude,
        longitude: dispatchUpdate?.assignedDriver?.latitude || dispatchUpdate.latitude
      }
    },
    id: dispatchUpdate.id,
    bsCompanyId: null,
    clearCode: null,
    comments: null,
    providerId: dispatchUpdate.providerId,
    eta: dispatchUpdate.eta,
    jobId: dispatchUpdate.jobId,
    locationId: dispatchUpdate.locationId,
    motorClubKey: dispatchUpdate.motorClubKey,
    phone: dispatchUpdate.phone,
    purchaseOrderId: dispatchUpdate.purchaseOrderId,
    dispatchId: dispatchUpdate.dispatchId,
    responseId: dispatchUpdate.responseId,
    sourceType: dispatchUpdate.sourceType,
    status: dispatchUpdate.status,
    updateTimeStamp: dispatchUpdate.updateTimeStamp ?? dispatchUpdate.dateModified,
    qoreDispatchStatusId: dispatchUpdate.qoreDispatchStatusId,
    zip: dispatchUpdate.zip,
    dateCreated: dispatchUpdate.dateCreated,
    dateModified: dispatchUpdate.dateModified,
  };
}

/**
  * @param {Object} dispatchUpdate
  * @returns {Object}
*/
export function towBookDispatchLocationUpdateParser(dispatchUpdate) {
  return {
    assignedDriver: null,
    assignedVehicle: {
      geoPoint: {
        latitude: dispatchUpdate.latitude,
        longitude: dispatchUpdate.longitude
      },
      gpsLastUpdate: dispatchUpdate.updateTimeStamp ?? dispatchUpdate.dateModified,
    },
    id: dispatchUpdate.id,
    bsCompanyId: null,
    clearCode: null,
    comments: null,
    providerId: dispatchUpdate.providerId,
    eta: dispatchUpdate.eta,
    jobId: dispatchUpdate.jobId,
    locationId: dispatchUpdate.locationId,
    motorClubKey: dispatchUpdate.motorClubKey,
    phone: dispatchUpdate.phone,
    purchaseOrderId: dispatchUpdate.purchaseOrderId,
    dispatchId: dispatchUpdate.dispatchId,
    responseId: dispatchUpdate.responseId,
    sourceType: dispatchUpdate.sourceType,
    status: dispatchUpdate.status,
    updateTimeStamp: dispatchUpdate.updateTimeStamp ?? dispatchUpdate.dateModified,
    qoreDispatchStatusId: dispatchUpdate.qoreDispatchStatusId,
    zip: dispatchUpdate.zip,
    dateCreated: dispatchUpdate.dateCreated,
    dateModified: dispatchUpdate.dateModified,
  };
}

/**
  * @param {Object} dispatchUpdate
  * @returns {Object}
*/
export function towBookDispatchPostApprovalUpdateParser(postApprovalUpdate) {
  return {
    assignedDriver: null,
    assignedVehicle: {
      geoPoint: {
        latitude: postApprovalUpdate.latitude,
        longitude: postApprovalUpdate.longitude
      }
    },
    id: postApprovalUpdate.id,
    updateType: postApprovalUpdate.updateType,
    bsCompanyId: null,
    clearCode: null,
    providerComments: postApprovalUpdate.providerComments,
    providerId: Number(postApprovalUpdate.providerId),
    eta: postApprovalUpdate.eta,
    jobId: postApprovalUpdate.jobId,
    locationId: postApprovalUpdate.locationId,
    motorClubKey: postApprovalUpdate.motorClubKey,
    phone: postApprovalUpdate.phone,
    purchaseOrderId: postApprovalUpdate.purchaseOrderId,
    dispatchId: Number(postApprovalUpdate.dispatchId),
    responseId: postApprovalUpdate.responseId,
    sourceType: postApprovalUpdate.sourceType,
    status: postApprovalUpdate.status,
    updateTimeStamp: postApprovalUpdate.updateTimeStamp ?? postApprovalUpdate.dateModified,
    qoreDispatchStatusId: postApprovalUpdate.qoreDispatchStatusId,
    zip: postApprovalUpdate.zip,
    motorClubResponse: postApprovalUpdate.motorClubResponse,
    dateCreated: postApprovalUpdate.dateCreated,
    dateModified: postApprovalUpdate.dateModified,
    digitalProviderNetwork: postApprovalUpdate.digitalProviderNetwork,
    motorClubResponseNotes: postApprovalUpdate.motorClubResponseNotes
  };
}
